<template>
  <div class="tw-h-full tw-bg-gray-800 tw-text-gray-300 tw-border-l tw-border-gray-700 tw-p-6 tw-overflow-y-auto">
    <div v-if="clientExplorerStore.selectedEntity">
      <button class="tw-bg-blue-500 tw-text-white tw-font-bold tw-py-2 tw-px-4 tw-rounded tw-mb-4">Edit</button>
      <h2 class="tw-text-2xl tw-font-bold tw-mb-4">{{ selectedEntityDescription }}</h2>

      <h3 class="tw-text-xl tw-font-bold tw-mb-2">Attributes</h3>
      <ul class="tw-space-y-2 tw-mb-6">
        <li v-for="attribute in entityAttributes" :key="attribute.field" class="tw-flex tw-justify-between tw-gap-4">
          <span class="tw-font-medium">{{ attribute.field }}</span>
          <span>{{ attribute.value }}</span>
        </li>
      </ul>

      <h3 class="tw-text-xl tw-font-bold tw-mb-2">Belongs to:</h3>
      <div v-if="parentEntities.length == 0" class="tw-mb-6">[]</div>
      <ul v-else class="tw-space-y-2 tw-mb-6">
        <li v-for="parentEntity in parentEntities" :key="parentEntity.id">
          <span class="tw-text-blue-400">
            ({{ parentEntity.entity_type }}) {{ parentEntity.description }}
          </span>
        </li>
      </ul>

      <h3 class="tw-text-xl tw-font-bold tw-mb-2">Has:</h3>
      <div v-if="childEntities.length == 0" class="tw-mb-6">[]</div>
      <ul v-else class="tw-space-y-2">
        <li v-for="childEntity in childEntities" :key="childEntity.id">
          <span class="tw-text-blue-400">
            ({{ childEntity.entity_type }}) {{ childEntity.description }}
          </span>
        </li>
      </ul>
    </div>
    <div v-else class="tw-flex tw-items-center tw-justify-center tw-h-full">
      <p class="tw-text-gray-500">Hover over an entity to view details</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'client-explorer-detail-view',
  inject: ['getClientExplorerStore'],
  computed: {
    clientExplorerStore() {
      return this.getClientExplorerStore();
    },
    selectedEntityDescription() {
      return this.clientExplorerStore.selectedEntity?.description || '';
    },
    entityAttributes() {
      const { parent_entities, child_entities, ...additional_attributes } = this.clientExplorerStore.selectedEntity || {};
      return Object.entries(additional_attributes)
        .filter(([field, value]) => !!value)
        .map(([field, value]) => ({ field: this.getReadableAttributeName(field), value }));
    },
    parentEntities() {
      return (this.clientExplorerStore.selectedEntity?.parent_entities || [])
        .map(entityId => this.clientExplorerStore.getEntity(entityId))
        .filter(Boolean);
    },
    childEntities() {
      return (this.clientExplorerStore.selectedEntity?.child_entities || [])
        .map(entityId => this.clientExplorerStore.getEntity(entityId))
        .filter(Boolean);
    },
  },
  methods: {
    getReadableAttributeName(name) {
      return name.split('_').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
    },
  },
};
</script>
